import React, {useContext} from 'react';

const ChildContext = React.createContext(null);

export const useChildContext = () =>  useContext(ChildContext) ;

export default ChildContext;